import local from '../classes/local';

export default function getSite() {
    const url = window.location.href;
    if (url.includes('healthcare.gov') || url.includes('cuidadodesalud.gov'))
        return local.setItem('site', 'healthcare.gov');
    if (url.includes('cms.gov'))
        return local.setItem('site', 'cms.gov');
    if (url.includes('mymedicare.gov'))
        return local.setItem('site', 'mymedicare.gov');
    if (url.includes('medicare.gov'))
        return local.setItem('site', 'medicare.gov');
    if (url.includes('medicaid.gov'))
        return local.setItem('site', 'medicaid.gov');
    if (url.includes('hhs.gov'))
        return local.setItem('site', 'hhs.gov');
    return local.getItem('site', 'healthcare.gov');
}